import styles from "./WifiAmenityModal.module.scss";
import Modal from "../../../Common/Modal/Modal";
import React from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function WifiAmenityModal(props: Props) {
  const { isOpen, setIsOpen } = props;

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseIcon={false}>
      <div className={styles.mainContainer}>
        <div className={styles.contentContainer}>
          <div className={styles.headingContainer}>
            <p className={styles.label}>Connect to Wifi</p>
          </div>
          <div className={styles.modalBodyContent}>
            <p>
              Open your device's WiFi settings, select "Amenities," then enter
              your Amenities portal username and password.
            </p>
          </div>
          <div className={styles.buttonsContainer}>
            <button
              className={styles.CancelButton}
              onClick={() => setIsOpen(false)}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default WifiAmenityModal;
